import axios from 'axios'

import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import axiosObj from './config'
import { handleQuery } from '../utils/request'

const REPORT_API_URL = `${process.env.API_URL}/reports/graphql`
const REPORT_UNSUBSCRIBE_API_URL = `${process.env.API_URL}/reports/unsubscribe`

const REPORT_RETURN_VALUES = {
  _id: true,
  name: true,
  description: true,
  creationInterval: true,
  creationTrigger: true,
  status: true,
  startDate: true,
  endDate: true,
  scheduledTime: true,
  timezone: true,
  tags: true,
  externalEmails: true,
  lastSentAt: true,
  nextSendAt: true,
  createdAt: true,
  updatedAt: true,
  dashboard: {
    _id: true,
    name: true,
    locations: {
      _id: true,
      name: true,
      visibility: true
    }
  },
  recipients: {
    _id: true,
    firstName: true,
    lastName: true
  },
  createdBy: {
    _id: true,
    firstName: true,
    lastName: true
  },
  locations: {
    _id: true,
    name: true,
    visibility: true
  },
  reports: {
    _id: true,
    status: true,
    mode: true,
    externalEmails: true,
    format: true,
    url: true,
    createdAt: true,
    updatedAt: true,
    recipients: {
      _id: true,
      firstName: true,
      lastName: true
    }
  }
};

export function getReportConfigTags(args) {
  const query = {
    query: {
      reportConfigTags: {
        __args: args
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function updateReportConfigTags(args) {
  const query = {
    mutation: {
      bulkUpdateReportConfigTags: {
        __args: args,
      },
    },
  }
  return handleQuery(query, REPORT_API_URL)
}

export function createReportConfig(params) {
  const query = {
    mutation: {
      createReportConfig: {
        __args: params
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function updateReportConfig(params) {
  const query = {
    mutation: {
      updateReportConfig: {
        __args: params
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function getReportConfigs(params) {
  const query = {
    query: {
      reportConfigs: {
        __args: params,
        count: true,
        data: REPORT_RETURN_VALUES
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function getReportConfig(params) {
  const query = {
    query: {
      reportConfig: {
        __args: params,
        ...REPORT_RETURN_VALUES
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function activateReportConfigs(params) {
  const query = {
    mutation: {
      activateReportConfigs: {
        __args: params
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function cloneReportConfig(params) {
  const query = {
    mutation: {
      cloneReportConfig: {
        __args: params
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function deleteReportConfigs(params) {
  const query = {
    mutation: {
      deleteReportConfigs: {
        __args: params
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function sendReport(params) {
  const query = {
    mutation: {
      sendReport: {
        __args: params
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function deleteReport(params) {
  const query = {
    mutation: {
      deleteReport: {
        __args: params
      }
    }
  }
  return handleQuery(query, REPORT_API_URL)
}

export function unsubscribeReport(token) {
  return axios({
    method: 'post',
    url: REPORT_UNSUBSCRIBE_API_URL,
    headers: {
      'Content-Type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });
}